import "./CardGroup.scss";

interface CardGroupProps {
  children?: React.ReactNode;
  layout?: "grid" | "masonry";
}

export const CardGroup: React.FC<CardGroupProps> = ({ children, layout = "grid" }) => {
  const layoutClass = `card-group--${layout}`;

  return <div className={`card-group ${layoutClass}`}>{children}</div>;
};
